import { isAxiosError } from 'axios';
import { hasPlatformError, extractPlatformError } from '@aviata/platform-fns';
import type { PlatformError } from '@aviata/platform-types';

export function extractFirstPlatformError(error: Error | unknown) {
  let current: Error | undefined | unknown = error;

  while (current) {
    if (isAxiosError(current)) {
      return hasPlatformError(current)
        ? extractPlatformError(current)
        : ({
            code: 'unknown',
            message: 'unknown',
            scope: 'unknown',
          } as unknown as PlatformError);
    }

    // @ts-expect-error cause is available in es2016
    current = current.cause as Error | undefined;
  }

  return null;
}
